module.exports = __webpack_public_path__ + "img/Windows.19802f6e.svg";